import { useState } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import DotMenuIcon from '../icons/DotMenuIcon';

const RevenueStreamMenu = ({ editUnits, deleteStream, id }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((open) => !open);

  return (
    <Dropdown
      id={`revenue-stream-menu-${id}`}
      isOpen={dropdownOpen}
      toggle={toggle}
      className="flex-shrink-0"
    >
      <DropdownToggle color="link">
        <DotMenuIcon />
      </DropdownToggle>
      <DropdownMenu positionFixed>
        <DropdownItem onClick={editUnits}>Edit units</DropdownItem>
        <DropdownItem onClick={deleteStream}>Delete channel</DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default RevenueStreamMenu;
